<template>
    <v-layout class="_greeting row wrap"
              :style="{backgroundColor: $auth.check(['parent']) ? 'var(--pink)' : 'var(--blue_light)'}">
        <v-container>
            <v-layout row wrap _greeting--layout>
                <v-flex class="xs12 text-xs-center mb-4">
                    <h2 class="d-inline-block">Welcome, {{ $auth.user().first_name }}.</h2>
                    <p v-if="unreadMsg"
                       class="app-text-regular d-inline-block"> You have {{unreadMsg}} new messages.</p>
                    <router-link v-if="unreadMsg"
                                 to="/inbox"
                                 class="text-small"
                                 tag="a">View messages
                    </router-link>
                </v-flex>
                <v-flex class="xs12 _greeting--divider">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="100%"
                         overflow="visible">
                        <defs>
                            <pattern id="divider" x="-4" y="0" width="132" height="15"
                                     viewBox='0 0 132 15'
                                     patternUnits="userSpaceOnUse">
                                <path d="M20.758 11a5.91 5.91 0 0 1-1.195-.113c-2.331-.422-3.905-2.45-4.954-3.803-1.603-2.057-2.332-3.015-4.663-3.719-2.303-.704-4.11.648-5.013 2.17-.874 1.436-1.807 2.676-2.798 3.69a1.244 1.244 0 0 1-1.749.028 1.147 1.147 0 0 1-.029-1.69 16.952 16.952 0 0 0 2.448-3.24c1.75-2.93 4.867-4.198 7.928-3.268 3.089.958 4.196 2.395 5.916 4.564.874 1.099 2.04 2.62 3.41 2.874 2.215.394 3.322-.986 4.954-3.24.554-.761 1.108-1.55 1.749-2.226C28.306 1.421 30.2.547 32.066.576c1.69.028 3.264.76 4.517 2.141.38.423.816.845 1.195 1.268.641.676 1.312 1.352 1.953 2.113 1.457 1.718 3.002 2.17 4.78 1.324.845-.394 1.457-.704 2.04-1.155.64-.507 1.136-1.24 1.66-2 .35-.508.7-1.043 1.137-1.55C50.602 1.28 52.554.351 54.594.237c3.09-.14 5.042 2.142 6.616 4.001.379.451.758.874 1.107 1.24 2.39 2.48 4.605 2.564 7.432.282.525-.423 1.05-.986 1.603-1.578.904-.958 1.836-1.944 2.973-2.564 1.865-1.042 5.45-1.521 7.402.254.7.62 1.312 1.268 1.924 1.887.758.79 1.486 1.522 2.331 2.226.787.676 1.312 1.07 2.215 1.352 1.749.536 2.973.085 4.75-1.718.496-.507.933-1.07 1.4-1.69.903-1.212 1.865-2.48 3.41-3.297 2.331-1.24 5.1-.62 7.402 1.634.991.986 1.982 2.057 3.206 3.55 1.078 1.296 2.302 2 3.526 2.057 1.137.056 2.303-.48 3.352-1.522.612-.591 1.137-1.267 1.72-1.972.378-.479.786-.958 1.194-1.437l.117-.112c.583-.648 1.195-1.353 1.953-1.888 1.981-1.38 4.633-1.24 6.44.395.875.788 1.69 1.634 2.478 2.422.582.592 1.194 1.212 1.777 1.775l.059.057c.787.732 1.573 1.493 2.419 2 .582.338.786 1.07.408 1.662-.35.564-1.108.76-1.72.395-1.107-.648-2.01-1.493-2.885-2.339l-.058-.056c-.642-.592-1.254-1.24-1.866-1.86-.757-.788-1.573-1.605-2.39-2.31-.932-.845-2.273-.93-3.293-.197-.524.366-1.02.93-1.544 1.493l-.117.113a28.69 28.69 0 0 0-1.137 1.352c-.582.733-1.194 1.465-1.894 2.141-1.545 1.55-3.38 2.339-5.246 2.254-1.982-.084-3.818-1.098-5.362-2.93a46.426 46.426 0 0 0-3.031-3.352c-.875-.874-2.623-2.17-4.43-1.212-1.05.564-1.807 1.55-2.594 2.592-.495.648-.99 1.352-1.632 1.972-1.807 1.803-3.934 3.325-7.286 2.339-1.37-.395-2.157-1.015-3.118-1.832-.933-.788-1.72-1.605-2.507-2.394-.583-.592-1.166-1.212-1.807-1.775-.874-.79-3.206-.592-4.459.084-.816.451-1.603 1.296-2.36 2.113-.583.62-1.195 1.268-1.837 1.803-3.817 3.071-7.577 2.93-10.841-.479a26.815 26.815 0 0 1-1.195-1.352c-1.399-1.662-2.74-3.24-4.546-3.127-1.341.056-2.653.676-3.44 1.606-.35.394-.64.845-.961 1.324-.612.873-1.224 1.803-2.157 2.536-.845.676-1.748 1.07-2.535 1.465-2.798 1.295-5.625.591-7.782-1.973-.583-.704-1.195-1.324-1.836-1.972L34.69 4.38c-.816-.873-1.72-1.324-2.681-1.352-1.137 0-2.39.592-3.44 1.69-.524.536-1.02 1.212-1.515 1.944C25.596 8.605 23.877 11 20.758 11z"
                                      :fill="$auth.check(['parent']) ? 'var(--orange)' : 'var(--green)'"/>
                            </pattern>
                        </defs>
                        <rect fill="url(#divider)" x="0" y="0" width="100%" height="15"/>
                    </svg>
                </v-flex>
            </v-layout>
        </v-container>
    </v-layout>
</template>

<script>
  export default {
    name: 'app-home-greeting',
    computed: {
      unreadMsg () {
        return this.$store.getters['notifications/messages']
      }
    }
  }
</script>

<style lang="stylus" scoped>
    ._greeting
        position relative
        min-height 150px
        &--layout
            padding-top 10px
            @media (min-width 600px)
                padding-top 30px
        &--divider
            height 15px
            max-width 75%
            margin auto
            @media (min-width 600px)
                height 50px
                max-width 100%
</style>



// WEBPACK FOOTER //
// src/views/app/home/components/app-home-greeting.vue